import * as React from 'react';

import { extractNumber } from '../../utils/extractNumber';

export const setBubbleInitialState = (rootElement: HTMLElement, textClassName: string) => {
  rootElement.style.maxHeight = '100%';

  Array.from(rootElement.children).forEach(child => {
    const childElement = child as HTMLElement | null;
    if (!childElement) {
      return;
    }

    childElement.setAttribute('style', '');

    const textElement = childElement.querySelector(`.${CSS.escape(textClassName)}`) as HTMLElement | null;

    textElement?.style.setProperty('--linesCount', String(999));
  });
};

export const clampBubble = (
  rootElement: HTMLElement,
  maxHeight: number,
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>,
  expandButtonClassName: string,
  textClassName: string,
) => {
  rootElement.style.maxHeight = maxHeight + 'px';

  const rootPaddingBottom = extractNumber(window.getComputedStyle(rootElement).paddingBottom);

  const expandButton = rootElement.querySelector(`.${CSS.escape(expandButtonClassName)}`) as HTMLElement | null;

  const expandButtonMarginTop = expandButton ? extractNumber(window.getComputedStyle(expandButton).marginTop) : 0;

  let { offsetHeight: expandButtonHeight } = expandButton || {
    offsetHeight: 0,
  };

  expandButtonHeight += expandButtonMarginTop;

  let hiddenOrClampedChildrenCount = 0;

  Array.from(rootElement.children)
    // reverse – потому что начинаем смотреть с последнего элемента, который с наибольшей вероятностью будет скрыт
    .reverse()
    .forEach(child => {
      const childElement = child as HTMLElement | null;
      if (!childElement || childElement.tagName.toLowerCase() === 'button') {
        return;
      }

      const { offsetTop: childTop, offsetHeight: childHeight } = childElement;
      const childBottomBorder = childTop + childHeight;

      /** находится ли текущий элемент за границами допустимой области видимости (макс. высоты) */
      const childOutsideMaxHeight = childTop > maxHeight - rootPaddingBottom;

      if (childOutsideMaxHeight) {
        hiddenOrClampedChildrenCount++;
        childElement.style.display = 'none';
      }

      /** пересекает ли текущий элемент максимальную высоту (т.е. нижнюю границу родительского блока) */
      const childIntersectsMaxHeight = childBottomBorder >= maxHeight - rootPaddingBottom;

      // если хотя бы один чилдрен пересекает нижнюю границу (либо целиком находится за её пределами снизу), нужно пересчитать высоту с учетом кнопки "читать полностью"
      if (childIntersectsMaxHeight || hiddenOrClampedChildrenCount) {
        hiddenOrClampedChildrenCount++;
        /** высота родительского блока до элемента, часть которого должна остаться видна */
        const spaceBeforeChild = maxHeight - childTop;
        /** свободное место, которое необходимо оставить для отступа и кнопки "читать полностью" */
        const rootElementBottomFreeSpace = rootPaddingBottom + expandButtonHeight;

        let allowedChildHeight = spaceBeforeChild - rootElementBottomFreeSpace;
        // если значение уходит в минус, считаем, что места для элемента не осталось
        allowedChildHeight = allowedChildHeight >= 0 ? allowedChildHeight : 0;

        childElement.style.maxHeight = allowedChildHeight + 'px';

        const textElement = childElement.querySelector(`.${CSS.escape(textClassName)}`) as HTMLElement | null;

        if (!textElement) {
          return;
        }

        const linesCount = Math.floor(textElement.offsetHeight / 24);

        if (linesCount === 0) {
          childElement.style.display = 'none';
        }

        textElement.style.setProperty('--linesCount', String(linesCount));

        return;
      }
    });

  if (!hiddenOrClampedChildrenCount) {
    setIsCollapsed(false);
  }
};
